import api from './api';

export interface ProductPurchaseData {
  eventId: string;
  productId: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  quantity: number;
  legalAccepted?: { key: string; version: string }[];
}

export interface ProductPurchase {
  _id: string;
  eventId: string;
  productId: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  quantity: number;
  totalAmount: number;
  status: 'pending' | 'confirmed' | 'cancelled';
  paymentStatus: 'pending' | 'paid' | 'failed' | 'refunded';
  transactionId?: string;
  confirmationCode: string;
  createdAt: string;
  updatedAt: string;
  // Propriedades adicionadas pelo backend
  eventTitle?: string;
  eventSlug?: string;
  productName?: string;
  productPrice?: number;
  productImage?: string;
}

// Criar compra de produto
export const createProductPurchase = async (data: ProductPurchaseData) => {
  try {
    const response = await api.post('/product-purchases', data);
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Falha ao criar compra de produto';
    throw new Error(message);
  }
};

// Buscar compra por ID
export const getProductPurchaseById = async (id: string) => {
  try {
    const response = await api.get(`/product-purchases/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar compra:', error);
    throw new Error('Falha ao buscar compra');
  }
};

// Buscar compra por código de confirmação
export const getProductPurchaseByConfirmationCode = async (confirmationCode: string) => {
  try {
    const response = await api.get(`/product-purchases/confirmation/${confirmationCode}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar compra por código:', error);
    throw new Error('Falha ao buscar compra');
  }
};

// Buscar compras por evento (para dashboard)
export const getProductPurchasesByEvent = async (eventId: string) => {
  try {
    const response = await api.get(`/product-purchases/event/${eventId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar compras do evento:', error);
    throw new Error('Falha ao buscar compras do evento');
  }
};

// Atualizar status da compra
export const updateProductPurchaseStatus = async (id: string, status: string, paymentStatus: string) => {
  try {
    const response = await api.patch(`/product-purchases/${id}/status`, {
      status,
      paymentStatus
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar status da compra:', error);
    throw new Error('Falha ao atualizar status da compra');
  }
};

// Buscar todas as compras de produtos da paróquia (para dashboard)
export const getAllProductPurchases = async () => {
  try {
    const response = await api.get('/dashboard/product-purchases');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar compras de produtos:', error);
    throw new Error('Falha ao buscar compras de produtos');
  }
}; 